export const MarkerClusterTemplate = cicleColor => `
<svg width='40px' height='40px' xmlns='http://www.w3.org/2000/svg'>
  <circle cx='20' cy='20' r='20' fill='${cicleColor}' />
</svg>
`
